<template>
  <hm-content title>
    <div class="flex flex-between mb20">
    <div class="flex item-center">
      <span class="mr20">提现账号配置</span>
      <el-button type="primary" size="small" @click="addWithdrawAccount">添加提现账号</el-button>
      <span class="ml20 red">兜底账号至少一个，否则全部规则不生效</span>
    </div>
    <div class="table-panel flex flex-end">
      <div>
        <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="账号类型"
          v-model="searchCondition.type"
          style="width: 200px"
          filterable
        >
          <el-option
            v-for="(item, i) in accountTypeList"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          clearable
          v-model.trim="searchCondition.sendName"
          placeholder="请输入账号"
          size="small"
          class="ipt mr10"
          style="width: 200px"
        ></el-input>
      </div>
      <div>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    </div>
    <el-table
      :data="list"
      style="width: 100%"
      ref="table"
      stripe
      border
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="账号类型"
        prop="type"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.type==='wechat'">微信</div>
          <div v-if="scope.row.type==='wechat_v3'">微信V3</div>
          <div v-if="scope.row.type==='alipay'">支付宝</div>
          <div v-if="scope.row.type==='bank'">银行卡</div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="账号"
        prop="sendName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="单次支出上下限"
        prop="maxLimit "
      >
        <template slot-scope="scope">
          {{scope.row.minLimit}} - {{scope.row.maxLimit}}
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="每日支出上下限"
        prop="dayMaxLimit"
      >
      <template slot-scope="scope">
        {{scope.row.dayMinLimit}} - {{scope.row.dayMaxLimit}}
      </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="单月支出上下限"
        prop="monthMaxLimit"
      >
      <template slot-scope="scope">
        {{scope.row.monthMinLimit}} - {{scope.row.monthMaxLimit}}
      </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="关联提现规则"
        prop="ruleLimit"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="关联第三方协议"
        prop="contractName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="是否兜底账号"
        prop="isDefault"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.isDefault==='1'">是</div>
          <div v-else>否</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        header-align="center"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-button size="small" type="text" @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button size="small" type="text" @click="record(scope.row)"
              >流水记录</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @size-change="handleSizeChange"
        @current-change="paging"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
    >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="200px"
    >
      <div>
        <el-form-item class="mb10" label="账号类型:" prop="type">
          <el-select
            size="small"
            clearable
            class="mr10"
            placeholder="账号类型"
            v-model="ruleForm.type"
            style="width: 200px"
            filterable
          >
            <el-option
              v-for="(item, i) in accountTypeList"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="mb10" label="支付账号:" prop="sendName">
          <el-input
            clearable
            v-model.trim="ruleForm.sendName"
            placeholder="请输入支付账号"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        <el-form-item class="mb10" label="商户ID:" prop="mchId">
          <el-input
            clearable
            v-model.trim="ruleForm.mchId"
            placeholder="请输入商户ID"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        <el-form-item class="mb10" label="单次支出上下限:" prop="Limit">
          <el-input
            clearable
            v-model.trim="ruleForm.minLimit"
            placeholder="请输入单次支出下限"
            size="small"
            class="ipt mr10"
            maxlength="10"
            style="width:150px;"
            @input="filterGt0('minLimit')"
          ></el-input>
          <span>-</span>
          <el-input
            clearable
            v-model.trim="ruleForm.maxLimit"
            placeholder="请输入单次支出上限"
            size="small"
            class="ipt ml10"
            maxlength="10"
            style="width:150px;"
            @input="filterGt0('maxLimit')"
          ></el-input>
        </el-form-item>
        <el-form-item class="mb10" label="单日支出上下限:" prop="dayLimit">
          <el-input
            clearable
            v-model.trim="ruleForm.dayMinLimit"
            placeholder="请输入单日支出下限"
            size="small"
            class="ipt mr10"
            maxlength="10"
            style="width:150px;"
            @input="filterGt0('dayMinLimit')"
          ></el-input>
          <span>-</span>
          <el-input
            clearable
            v-model.trim="ruleForm.dayMaxLimit"
            placeholder="请输入单日支出下限"
            size="small"
            class="ipt ml10"
            maxlength="10"
            style="width:150px;"
            @input="filterGt0('dayMaxLimit')"
          ></el-input>
        </el-form-item>
        <el-form-item class="mb10" label="单月支出上下限:" prop="monthLimit">
          <el-input
            clearable
            v-model.trim="ruleForm.monthMinLimit"
            placeholder="请输入单月支出下限"
            size="small"
            class="ipt mr10"
            maxlength="10"
            style="width:150px;"
            @input="filterGt0('monthMinLimit')"
          ></el-input>
          <span>-</span>
          <el-input
            clearable
            v-model.trim="ruleForm.monthMaxLimit"
            placeholder="请输入单月支出下限"
            size="small"
            class="ipt ml10"
            maxlength="10"
            style="width:150px;"
            @input="filterGt0('monthMaxLimit')"
          ></el-input>
        </el-form-item>
        <el-form-item class="mb10" label="是否兜底账号:" prop="isDefault">
          <el-radio-group
            v-model="ruleForm.isDefault"
          >
            <el-radio label="1">
              是
            </el-radio>
            <el-radio label="0">
              否
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="支付密钥:">
          <el-input
            size="small"
            v-model="ruleForm.certificateKey"
            type="textarea"
            placeholder="请输入支付密钥"
            style="width:380px;"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="私钥:">
          <el-input
            size="small"
            v-model="ruleForm.certificateUrl"
            type="textarea"
            placeholder="请输入私钥"
            style="width:380px;"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="wxKey:" v-if="ruleForm.type==='wechat'">
          <el-input
            size="small"
            v-model="ruleForm.wxKey"
            type="textarea"
            placeholder="请输入wxKey"
            style="width:380px;"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="wxappid:" v-if="ruleForm.type==='wechat'">
          <el-input
            size="small"
            v-model="ruleForm.wxappid"
            type="textarea"
            placeholder="请输入wxappid"
            style="width:380px;"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="alipayCertPath:" v-if="ruleForm.type==='alipay'">
          <el-input
            size="small"
            v-model="ruleForm.alipayCertPath"
            type="textarea"
            placeholder="请输入alipayCertPath"
            style="width:380px;"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="alipayPrivateKey:" v-if="ruleForm.type==='alipay'">
          <el-input
            size="small"
            v-model="ruleForm.alipayPrivateKey"
            type="textarea"
            placeholder="请输入alipayPrivateKey"
            style="width:380px;"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="alipayPublicCertContent:" v-if="ruleForm.type==='alipay'">
          <el-input
            size="small"
            v-model="ruleForm.alipayPublicCertContent"
            type="textarea"
            placeholder="请输入alipayPublicCertContent"
            style="width:380px;"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="alipayRootCertPath:" v-if="ruleForm.type==='alipay'">
          <el-input
            size="small"
            v-model="ruleForm.alipayRootCertPath"
            type="textarea"
            placeholder="请输入alipayRootCertPath"
            style="width:380px;"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="场景值:" v-if="ruleForm.type==='wechat_v3'">
          <el-input
              size="small"
              v-model="ruleForm.sceneId"
              type="textarea"
              placeholder="请输入场景值"
              style="width:380px;"
              :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户序列号:" v-if="ruleForm.type==='wechat_v3'">
          <el-input
              size="small"
              v-model="ruleForm.mchSerialNo"
              type="textarea"
              placeholder="请输入商户序列号"
              style="width:380px;"
              :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="微信平台公钥文件路径:" v-if="ruleForm.type==='wechat_v3'">
          <el-input
              size="small"
              v-model="ruleForm.platFormKeyFile"
              type="textarea"
              placeholder="请输入微信平台公钥文件路径"
              style="width:380px;"
              :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="微信序列号:" v-if="ruleForm.type==='wechat_v3'">
          <el-input
              size="small"
              v-model="ruleForm.wechatSerialNo"
              type="textarea"
              placeholder="请输入微信序列号"
              style="width:380px;"
              :rows="4"
          ></el-input>
        </el-form-item>
      </div>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="submitForm('ruleForm')"
          >保存</el-button
        >
        <el-button size="small" @click="dialogVisible = false"
          >取消</el-button
        >
      </div>
    </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
import area from "@/utils/area";
export default {
  components: {},
  data() {
    const patterndRuleFuncLimit = (rule, val, callback) => {
      let falg = false;
      if(this.ruleForm.minLimit === "" || this.ruleForm.maxLimit === ""){
        falg = true;
        if (falg) {
          return callback(new Error("请输入必填项"));
        }
      }
      if(this.ruleForm.minLimit != "" && this.ruleForm.maxLimit != "" && parseInt(this.ruleForm.minLimit) > parseInt(this.ruleForm.maxLimit)){
        falg = true;
        if (falg) {
          return callback(new Error("请输入正确的阶梯"));
        }
      }
      callback();
    };
    const patterndRuleFuncdayLimit = (rule, val, callback) => {
      let falg = false;
      if(this.ruleForm.dayMinLimit === "" || this.ruleForm.dayMaxLimit === ""){
        falg = true;
        if (falg) {
          return callback(new Error("请输入必填项"));
        }
      }
      if(this.ruleForm.dayMinLimit != "" && this.ruleForm.dayMaxLimit != "" && parseInt(this.ruleForm.dayMinLimit) > parseInt(this.ruleForm.dayMaxLimit)){
        falg = true;
        if (falg) {
          return callback(new Error("请输入正确的阶梯"));
        }
      }
      callback();
    };
    const patterndRuleFuncmonthLimit = (rule, val, callback) => {
      let falg = false;
      if(this.ruleForm.monthMinLimit === "" || this.ruleForm.monthMaxLimit === ""){
        falg = true;
        if (falg) {
          return callback(new Error("请输入必填项"));
        }
      }
      if(this.ruleForm.monthMinLimit != "" && this.ruleForm.monthMaxLimit != "" && parseInt(this.ruleForm.monthMinLimit) > parseInt(this.ruleForm.monthMaxLimit)){
        falg = true;
        if (falg) {
          return callback(new Error("请输入正确的阶梯"));
        }
      }
      callback();
    };
    return {
      type:"",
      accountTypeList: [
        {
          label: "微信",
          value: "wechat",
        },
        {
          label: "微信V3",
          value: "wechat_v3",
        },
        {
          label: "支付宝",
          value: "alipay",
        },
        {
          label: "银行卡",
          value: "bank",
        }
      ],
      searchCondition:{
        type: "",
        mchId: "",
        sendName: "",
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      title: "添加提现账号",
      ruleForm:{
        type: "",
        sendName: "",
        mchId: "",
        minLimit: "",
        maxLimit: "",
        dayMinLimit: "",
        dayMaxLimit: "",
        monthMinLimit: "",
        monthMaxLimit: "",
        isDefault: "0",
        certificateKey: "",
        certificateUrl: "",
        wxKey: "",
        wxappid: "",
        alipayCertPath: "",
        alipayPrivateKey: "",
        alipayPublicCertContent: "",
        alipayRootCertPath: "",
        sceneId: "PRODUCT_1",
        notifyWay: "MINI_PROGRAM_JSAPI",
        mchSerialNo: "",
        platFormKeyFile: "",
        wechatSerialNo: "",
      },
      rules: {
        type: {
          required: true,
          message: "请选择账号类型"
        },
        sendName: {
          required: true,
          message: "请输入支付账号"
        },
        mchId: {
          required: true,
          message: "请输入商户ID"
        },
        Limit: [
          {
            required: true,
            validator: patterndRuleFuncLimit,
            trigger: "blur"
          }
        ],
        dayLimit: [
          {
            required: true,
            validator: patterndRuleFuncdayLimit,
            trigger: "blur"
          }
        ],
        monthLimit: [
          {
            required: true,
            validator: patterndRuleFuncmonthLimit,
            trigger: "blur"
          }
        ],
      },
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async queryList() {
      let conditions = JSON.parse(JSON.stringify(this.searchCondition));
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      Object.assign(params, conditions);
      const { result } = await this.$store.dispatch(
        "getcashQueryPageList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    addWithdrawAccount(){
      this.title = "添加提现账号";
      this.type = "add";
      this.ruleForm={
        type: "",
        sendName: "",
        mchId: "",
        minLimit: "",
        maxLimit: "",
        dayMinLimit: "",
        dayMaxLimit: "",
        monthMinLimit: "",
        monthMaxLimit: "",
        isDefault: "0",
        certificateKey: "",
        certificateUrl: "",
        wxKey: "",
        wxappid: "",
        alipayCertPath: "",
        alipayPrivateKey: "",
        alipayPublicCertContent: "",
        alipayRootCertPath: "",
        sceneId: "PRODUCT_1",
        notifyWay: "MINI_PROGRAM_JSAPI",
      },
      this.dialogVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
        let name = "";
        if(this.type==='add'){
          name = "getcashSave";
        }else if(this.type==="edit"){
          name = "getcashUpdate";
        }
        if(this.ruleForm.type==='wechat' && !this.ruleForm.wxKey){
          this.$message({
            message: "请输入wxKey",
            type: "warning"
          });
          return;
        }
        if(this.ruleForm.type==='wechat' && !this.ruleForm.wxappid){
          this.$message({
            message: "请输入wxappid",
            type: "warning"
          });
          return;
        }
        if(this.ruleForm.type==='alipay' && !this.ruleForm.alipayCertPath){
          this.$message({
            message: "请输入alipayCertPath",
            type: "warning"
          });
          return;
        }
        if(this.ruleForm.type==='alipay' && !this.ruleForm.alipayPrivateKey){
          this.$message({
            message: "请输入alipayPrivateKey",
            type: "warning"
          });
          return;
        }
        if(this.ruleForm.type==='alipay' && !this.ruleForm.alipayPublicCertContent){
          this.$message({
            message: "请输入alipayPublicCertContent",
            type: "warning"
          });
          return;
        }
        if(this.ruleForm.type==='alipay' && !this.ruleForm.alipayRootCertPath){
          this.$message({
            message: "请输入alipayRootCertPath",
            type: "warning"
          });
          return;
        }
        if(this.ruleForm.type==='wechat_v3' && !this.ruleForm.mchSerialNo){
          this.$message({
            message: "请输入微信支付V3商户序列号",
            type: "warning"
          });
          return;
        }
        if(this.ruleForm.type==='wechat_v3' && !this.ruleForm.platFormKeyFile){
            this.$message({
              message: "请输入微信平台公钥文件路径",
              type: "warning"
            });
            return;
        }
        if(this.ruleForm.type==='wechat_v3' && !this.ruleForm.wechatSerialNo){
          this.$message({
            message: "请输入微信支付V3微信序列号",
            type: "warning"
          });
          return;
        }
        let params = JSON.parse(JSON.stringify(this[formName]));
        this.$store.dispatch(name, params).then(res => {
          if (res.code == "0") {
            this.innerVisible = false;
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.dialogVisible = false;
            this.queryList();
          }
        });
        }
      });
    },
    async edit(row){
      console.log("row:",row);
      let params = {
        id:row.id,
      };
      const { result } = await this.$store.dispatch(
        "getcashGet",
        params
      );
      if(result){
        this.type = "edit";
        this.ruleForm = result;
        this.dialogVisible = true;
      }
      console.log("result:",result);
    },
    record(row){
      let mchId = row.mchId;
      console.log("mchId:",mchId);
      this.$router.push({
        name: "DealRecord",
        query: {
          mchId,
        },
      });
    },
    // 过滤大于0
    filterGt0(prop) {
      if (this.ruleForm[prop].length === 1) {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/[^0-9]/g, "");
      } else {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|\D/g, "");
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.red{
  color: #E50065;
}
</style>
